export default [

{
  path: '/roles',
  name: 'roles',
  component: () => import(/* webpackChunkName: "roles" */ '@/pages/roles/RolesPage.vue')
},

]
